// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import adminMinJs from './assets/js/app.min.js';
import boostrapJs from '../node_modules/bootstrap/dist/js/bootstrap.min.js';
import Vue from 'vue'
import router from './router/router'
import store from './vuex/store'
import vueResource from 'vue-resource'
import VueNoty from 'vuejs-noty'
import VeeValidate from 'vee-validate';
import MaskedInput from 'vue-text-mask'
import vbclass from 'vue-body-class'
import searchmember from './components/Communs/searchMember.vue'
import searchGeneral from './components/Communs/searchGeneral.vue'
import searchclub from './components/Communs/searchClub.vue'
import BootstrapVue from 'bootstrap-vue'
import VueClipboard from 'vue-clipboard2'
import VuejsDialog from "vuejs-dialog"
import ChartJS from 'vue-chartjs'
import './utils'
import VueHtml2Canvas from 'vue-html2canvas';

/*REQUIRES*/
require('datatables.net');
require('datatables.net-bs');

Vue.use(VueHtml2Canvas);
Vue.use(vueResource)
Vue.use(VeeValidate, {fieldsBagName: 'veeFields'});
Vue.use(MaskedInput);
Vue.use(vbclass, router)
Vue.use(VueClipboard)
Vue.use(VueNoty, {
    theme: 'relax',
    timeout: 5000,
    progressBar: true,
})
Vue.use(BootstrapVue);
Vue.use(VuejsDialog);
Vue.use(ChartJS);

/*Déclaration des composants globaux */
Vue.component('masked-input', MaskedInput)
Vue.component('searchmember', searchmember)
Vue.component('searchclub', searchclub)
Vue.component('searchGeneral', searchGeneral)

Vue.config.productionTip = false

/* App sass */
import './assets/style/app.scss'

/* APP Component */
import App from './App'

/* Auth plugin */
import Auth from './auth'
Vue.use(Auth)


/* eslint-disable no-new */
new Vue({
    el: '#app',
    // Attach the Vue instance to the window,
    // so it's available globally.
    created: function () {
        window.Vue = this
    },
    router,
    store,
    render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js